//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { computed, defineComponent, ref, onMounted, useContext } from '@nuxtjs/composition-api';
import SfMenuItem from '~/themes/fiskarsMoominDefault/components/components/molecules/SfMenuItem/SfMenuItem.vue';
import SfModal from '~/themes/fiskarsMoominDefault/components/components/molecules/SfModal/SfModal.vue';
import SfList from '~/themes/fiskarsMoominDefault/components/components/organisms/SfList/SfList.vue';
import SfBar from '~/themes/fiskarsMoominDefault/components/components/molecules/SfBar/SfBar.vue';
import { useUiState } from '~/composables';
import LocaleSelectorButton from "~/components/LocaleSelectorButton.vue";


export default defineComponent({
  name: 'HeaderNavigation',
  components: {
    LocaleSelectorButton,
    SfMenuItem,
    SfModal,
    SfList,
    SfBar,
    MegaMenu: () => import('./MegaMenu.vue'),
  },
  props: {
    megaMenuContent: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const { isMobileMenuOpen, toggleMobileMenu} = useUiState();
    const { localePath } = useContext();
    const closeModal = () => {
      if(isMobileMenuOpen.value)
        toggleMobileMenu();
      updateMegaMenu(false);
    };

    let activeMegaMenu = ref({});


    const updateMegaMenu = (menuItem, isMobile = false) => {
      if (!menuItem?.sublevel) {
        activeMegaMenu.value = {};
        return;
      }

      const menuItemCopy = JSON.parse(JSON.stringify(menuItem));

      if (isMobile) {
        menuItemCopy.sublevel.unshift({
          name: menuItemCopy.name,
          menuname: menuItemCopy.menuname,
          sublevel: [],
          link: { href: localePath(menuItemCopy?.link?.href) },
        });

        menuItemCopy.sublevel.forEach((menuItemChild) => {
          if (menuItemChild.sublevel && menuItemChild.sublevel.length) {
            menuItemChild.sublevel.unshift({
              name: menuItemChild.name,
              menuname: menuItemChild.menuname,
              sublevel: [],
              link: { href: localePath(menuItemChild?.link?.href) },
            });
          }
        });
      }

      activeMegaMenu.value = { ...menuItemCopy, isMobile };
    }

    const showMegaMenu = (item) => {
      if(item)
        return activeMegaMenu.value.sublevel && activeMegaMenu.value.sublevel.length && !activeMegaMenu.value.isMobile && activeMegaMenu.value.menuname === item.menuname ;
      return activeMegaMenu.value.sublevel && activeMegaMenu.value.sublevel.length && activeMegaMenu.value.isMobile
    };

    const returnCharacters = computed (() => activeMegaMenu.value.characters ? activeMegaMenu.value.characters.items : []);
    const returnFeaturedItems = computed (() => activeMegaMenu.value.collection ? activeMegaMenu.value.collection.items : []);
    const returnAsideLink = computed(() => returnCharacters.value.length ? localePath(activeMegaMenu.value.characters?.link?.href) : returnFeaturedItems.value.length ? localePath(activeMegaMenu.value.collection?.link?.href) : '');
    const asideName = computed (() => activeMegaMenu.value.asideMenuName);
    const returnLink = (item, isDesktop, mobileDesign) => isDesktop && !mobileDesign ? localePath(item?.link?.href) : item?.sublevel.length ? '' : localePath(item?.link?.href);

    onMounted(() => closeModal())

    return {
      isMobileMenuOpen,
      toggleMobileMenu,
      returnAsideLink,
      closeModal,
      activeMegaMenu,
      updateMegaMenu,
      returnCharacters,
      returnFeaturedItems,
      asideName,
      showMegaMenu,
      returnLink
    };
  }
});
